import React, {
  useEffect,
  useMemo,
  useState,
  useContext,
  createContext,
} from "react";
import css from "./css/Application.module.css";
import { TopDisplay, Loading, Button } from "../../../ui-components";
import css2 from "./css/upload-btn.module.css";
import styles from "./css/display-applicant.module.css";
import styles2 from "./css/f-dropdown.module.css";
///Approvals/css/approval-table.module.css
import { AiOutlineSearch as SearchIcon } from "react-icons/ai";
import { IoReload as ReloadIcon } from "react-icons/io5";
import { BsFillCaretDownFill as Down } from "react-icons/bs";
import DisplayApplicant from "./DisplayApplicant";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { apiRequest, apiFormRequest, config } from "../../../api";
import ViewApplicantDetails from "./Modal/viewApplicant";
import fileDownload from "js-file-download";
import { NotificationContext } from "../../../providers/notification";
import { studentTemplate } from "./studentsTemplate";
import FileSaver from "file-saver";
import { ExNyRoute } from "../../../utils/allRouteId";

interface ApplicantDetails {
  ApplicantId: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Email: string;
  PhoneNumber: string;
  ContactAddress: string;
  Gender: string;
  Disablity?: any;
  IsSubmitted: boolean;
  RouteId: number;
  Title: string;
  BirthDate: string;
  WhatsAppNumber?: any;
  PhotoUrl: string;
  RouteName: string;
}

//export const ApplicantContext = createContext<any>({});
export const UploadBtn = (props: any) => {
  const [d_loading, set_d_loading] = useState<boolean>(false);
  const [file, setFile] = useState<any>("");
  const { showNotification } = useContext(NotificationContext);
  const { setShowModal, setShowTemplate } = useContext(ApplicantContext);

  const id = props.id || Number(ExNyRoute);
  // const handleShowTemplate=()=>{
  //     setShowTemplate(true);
  //     setShowModal(true)
  // }

  const handleDownloadStudentTemplate = () => {
    let dataBlob = studentTemplate;
    let sliceSize = 1024;
    let byteCharacters = atob(studentTemplate);
    let bytesLength = byteCharacters.length;
    let sliceCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(sliceCount);
    for (let sliceIndex = 0; sliceIndex < sliceCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);

      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }

      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    let blob = new Blob(byteArrays, { type: "application/vnd.ms-excel" });
    FileSaver.saveAs(new Blob([blob], {}), "CIPMStudentTemplate.xlsx");
  };
  const handleFileUplod = (e: any) => {
    const value = e.target.value;
    const fileValue = e.target.files[0];
    const apiData = new FormData();
    apiData.append("ExcelFile", fileValue);
    if (value && fileValue) {
      apiFormRequest("api/Applicant/UploadStudentsApplicant", apiData)
        .then((data: any) => {
          showNotification({
            message: data.Message,
            type: "success",
          });
        })
        .catch((err) => {
          showNotification({
            message: err.Message,
            type: "error",
          });
        });
    }
  };
  const handleDownload = () => {
    set_d_loading(true);
    let body: any = {
      routeId: id,
    };
    body = JSON.stringify(body);
    apiRequest(
      `api/Applicant/DownloadApplicants?routeId=${id}`,
      "GET",
      body,
      config,
      true
    )
      .then((data: any) => {
        if (!data?.Message) {
          fileDownload(
            data,
            `applicant-report${Math.floor(Math.random() * 10000) + 1}.xlsx`
          );
          showNotification({
            message: "File downloading...",
            type: "success",
          });
        } else {
          showNotification({
            message: data.Message || "No file to download",
            type: "success",
          });
        }

        set_d_loading(false);
      })
      .catch((error: any) => {
        showNotification({
          message: "Sorry File cannot be downloaded",
          type: "error",
        });
        set_d_loading(false);
      });
  };
  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <Button
        onClick={handleDownloadStudentTemplate}
        title="Click to see upload template sample"
      >
        Download Template
      </Button>

      <label className={css2.container}>
        <span>Upload Students Applicant</span>
        <input
          onChange={handleFileUplod}
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </label>
      <Button
        onClick={handleDownload}
        children={d_loading ? "Loading..." : "Download"}
        border="#E2E4E9"
        bg="#11643C"
        color="#E2E4E9;"
      />
    </div>
  );
};

export const ApplicantContext = createContext<any>({});

const Applicants = () => {
  const [showTemplate, setShowTemplate] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState<ApplicantDetails>(
    {} as ApplicantDetails
  );
  const [routeName, setRouteName] = useState("Examination / NYSC");
  const ApplicantsContextProvider = {
    showModal,
    setShowModal,
    showTemplate,
    setShowTemplate,
    modalData,
    setModalData,
  };

  return (
    <ApplicantContext.Provider value={ApplicantsContextProvider}>
      <div className={css.container}>
        <TopDisplay
          // subTitle={routeName}
          title="Applicants"
          btnText="Upload Applicant"
          showBtn={true}
          Btn={<UploadBtn />}
        />
        <DisplayApplicant setRouteName={setRouteName} />
        <ViewApplicantDetails
          data={modalData}
          showModal={showModal}
          onChange={setShowModal}
          setShowTemplate={setShowTemplate}
        />
      </div>
    </ApplicantContext.Provider>
  );
};

export default Applicants;

export const SearchForm = (props: any) => {
  const className = props.className
    ? `${props.className} ${styles.searchForm}`
    : styles.searchForm;
  return (
    <form className={className} {...props}>
      <span className={styles.sI}>
        <SearchIcon />
      </span>
      <input type="text" placeholder="Search" />
      <button className={styles.rBtn} type="submit">
        <ReloadIcon />
      </button>
    </form>
  );
};

export const FilterDropDown = (props: any) => {
  const [show, setShow] = useState<boolean | undefined>(false);
  const text: string = props.text ? props.text : "";
  const options: any = props.options ? props.options : [];
  const border: string = props.border ? props.border : "none";
  const bg: string = props.bg ? props.bg : "#f2f2f2";
  const color: string = props.color ? props.color : "#222";
  const onChange = props.onChange ? props.onChange : (e: any) => {};

  const handleSelected = (sel: any) => {
    onChange(sel);
    setShow(false);
  };
  
  return (
    <div className={styles2.container}>
      <button
        onClick={() => setShow(true)}
        className={styles2.btn}
        style={{ border, background: bg, color }}
      >
        {text}{" "}
        <span>
          <Down />
        </span>
      </button>

      {show ? (
        <>
          <div className={styles2.wrapper} onClick={() => setShow(false)}></div>
          <div className={styles2.drop}>
            {options && options.length > 0 ? (
              options.map((opt: any, index: number) => (
                <div key={index} onClick={() => handleSelected(opt)}>
                  {opt?.name}
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
